<template>
  <header id="header">
    <b-navbar role="navigation" toggleable="md" type="light" variant="faded">
      <b-navbar-toggle target="nav_collapse"></b-navbar-toggle>

      <b-navbar-brand>
        <b-link to="/">
          <img src="../../assets/FinalTransparent_164-50.png" height="50px" alt="Smart Marbles">
        </b-link>
      </b-navbar-brand>

      <b-collapse is-nav id="nav_collapse">
        <b-navbar-nav>
          <b-nav-item to="/about">About</b-nav-item>
          <b-nav-item to="/a11y">Accessibility</b-nav-item>
          <b-nav-item v-if="isAdmin" to="/labs">Labs</b-nav-item>
        </b-navbar-nav>

        <!-- Right aligned nav items -->
        <b-navbar-nav class="ml-auto">
          <b-nav-item v-if="!auth" to="/signup">Signup</b-nav-item>
          <b-nav-item v-if="!auth" to="/signin">Signin</b-nav-item>
          <b-nav-item-dropdown v-if="auth" right>
            <!-- Using button-content slot -->
            <template slot="button-content">
              <em>
                <font-awesome-icon icon="user"/>
              </em>
            </template>
            <b-dropdown-item to="/profile">Profile</b-dropdown-item>
            <b-dropdown-item @click="onLogout">Signout</b-dropdown-item>
          </b-nav-item-dropdown>
        </b-navbar-nav>
      </b-collapse>
    </b-navbar>
  </header>
</template>

<script>
export default {
  data() {
    return {
      // isAuth: false
    };
  },
  computed: {
    auth() {
      return this.$store.getters.isAuthenticated;
    },
    isAdmin() {
      return !this.$store.getters.user
        ? false
        : this.$store.getters.user.adminpermission;
    }
  },
  methods: {
    onLogout() {
      this.$store.dispatch("logout");
    }
  },
  created() {
    this.$store.dispatch("fetchUser");
  }
};
</script>